import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLayoutIframeComponent } from './app.layout-iframe.component';
import { SalesSimulatorModule } from '../sales/simulator/sales-simulator.module';

@NgModule({
  declarations: [
    AppLayoutIframeComponent
  ],
  imports: [
    CommonModule,
    SalesSimulatorModule
  ],
  exports: [
    AppLayoutIframeComponent
  ]
})
export class AppLayoutIframeModule { }